import { UserCountryCode, UserCountryCodes } from '@shared/types/countryCodes.ts';

export interface CampaignCountryMetadata {
  countryCode: UserCountryCode;
  isItalianCampaign: boolean;
  isSpanishCampaign: boolean;
  isGermanCampaign: boolean;
}

export function buildCampaignCountryMetadata(countryCode: UserCountryCode): CampaignCountryMetadata {
  return {
    countryCode,
    isItalianCampaign: countryCode === UserCountryCodes.IT,
    isSpanishCampaign: countryCode === UserCountryCodes.ES,
    isGermanCampaign: countryCode === UserCountryCodes.DE,
  };
}
